import {
  FETCH_FILTER_ORDER_TRANSACTION_HISTORY,
  FETCH_FILTER_ORDER_TRANSACTION_HISTORY_SUCCEED,
  FETCH_FILTER_ORDER_TRANSACTION_HISTORY_FAILED,
  FETCH_USER_ORDER_TRANSACTION_HISTORY,
  FETCH_USER_ORDER_TRANSACTION_HISTORY_SUCCEED,
  FETCH_USER_ORDER_TRANSACTION_HISTORY_FAILED,
  SEARCH_ORDER_TRANSACTION_BY_ID,
  SEARCH_ORDER_TRANSACTION_BY_ID_SUCCEED,
  SEARCH_ORDER_TRANSACTION_BY_ID_FAILED,
} from './action_types';

export default {
  fetchFilterTransactionHistoryAction: (params, callback) => ({
    type: FETCH_FILTER_ORDER_TRANSACTION_HISTORY,
    params,
    callback,
  }),

  fetchFilterTransactionHistoryActionSucced: (data, totalCount, callback) => ({
    type: FETCH_FILTER_ORDER_TRANSACTION_HISTORY_SUCCEED,
    params: {
      data,
      totalCount,
      callback,
    },
  }),

  fetchFilterTransactionHistoryActionFailed: (err) => ({
    type: FETCH_FILTER_ORDER_TRANSACTION_HISTORY_FAILED,
    params: {
      err,
    },
  }),

  searchOrderTransByIDAction: (params, callback) => ({
    type: SEARCH_ORDER_TRANSACTION_BY_ID,
    params,
    callback,
  }),

  searchOrderTransByIDActionSucceed: (data) => ({
    type: SEARCH_ORDER_TRANSACTION_BY_ID_SUCCEED,
    data,
  }),

  searchOrderTransByIDActionFailed: (err) => ({
    type: SEARCH_ORDER_TRANSACTION_BY_ID_FAILED,
    err,
  }),

  fetchUserOrderTransHistoryAction: (params, callback) => ({
    type: FETCH_USER_ORDER_TRANSACTION_HISTORY,
    params,
    callback,
  }),

  fetchUserOrderTransHistoryActionSucceed: (data, totalCount, callback) => ({
    type: FETCH_USER_ORDER_TRANSACTION_HISTORY_SUCCEED,
    params: {
      data,
      totalCount,
      callback,
    },
  }),

  fetchUserOrderTransHistoryActionFailed: (err) => ({
    type: FETCH_USER_ORDER_TRANSACTION_HISTORY_FAILED,
    params: {
      err,
    },
  }),
};
